import React from "react";

import {
    ContactModal,
    BookMeetingModal,
    UploadPolicyModal
} from './index'

export const modals = {
    contact: <ContactModal />,
    bookmeeting: <BookMeetingModal />,
    uploadpolicy: <UploadPolicyModal />
}

